import { Component, OnInit, ViewChild } from "@angular/core";
import { Utils } from "src/app/utils/utils";
import * as _moment from "moment";
import { Observable, Subject } from "rxjs";
import { DataTableDirective } from "angular-datatables";
import { InformeVentasProductoService } from "src/app/servicios/informe-ventas-producto.service";

@Component({
  selector: "app-informe-ventas-producto",
  templateUrl: "./informe-ventas-producto.component.html",
  styleUrls: ["./informe-ventas-producto.component.css"],
})
export class InformeVentasProductoComponent implements OnInit {
  @ViewChild(DataTableDirective)
  dtElement: DataTableDirective;

  dataVentaProducto = [];
  haveData = false;
  timeRunning = 0;
  dtTrigger = new Subject();

  infoFiltro: any;
  usuarioConsulta: any;
  dataFromFiltro: any;
  loading = false;

  dtOptions: any = {
    pagingType: "full_numbers",
    scrollX: true,
    dom: "Bfrtip",
    order: [],
    buttons: [
      "colvis",
      {
        extend: "copyHtml5",

        exportOptions: {
          columns: ":visible",
        },
      },
      {
        extend: "excelHtml5",
        fileName: "ResumenRecorrido" + ".xlsx",
        exportOptions: {
          columns: ":visible",
        },
        //CharSet: "utf8",
        exportData: { decodeEntities: true },
      },
    ],
  };

  constructor(
    public servicioInformeVentaProducto: InformeVentasProductoService,
    public ruta: Utils
  ) {
    const infoUsuario = JSON.parse(sessionStorage.getItem("infoUsuario"));
    this.usuarioConsulta = infoUsuario[0].IdUsuario;
    this.infoFiltro = {
      usuario: 0,
      agencia: 0,
      fechaInicial: new Date(),
      fechaFinal: new Date(),
      usuarioConsulta: this.usuarioConsulta,
      distribuidora: 0,
    };

    this.cargarInformacion(1);
  }

  ngOnInit(): void {
    this.ruta.setRuta();
  }

  dataFiltro(data) {
    console.log(data);
    this.dataFromFiltro = JSON.parse(data);
    this.cargarInformacion(2);
  }

  cargarInformacion(origen) {
    let usuarioConsulta = this.usuarioConsulta;
    let agencia = 0;
    let usuario = 0;
    let distribuidora = 0;
    let fechaInicial: any;
    let fechaFinal: any;
    this.loading = true;

    if (origen == 1) {
      fechaInicial = _moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD");
      fechaFinal = _moment(new Date(), "YYYY-MM-DD").format("YYYY-MM-DD");
    } else {
      agencia = this.dataFromFiltro.agencia;
      usuario = this.dataFromFiltro.usuario;
      distribuidora = this.dataFromFiltro.distribuidora;
      fechaInicial = this.dataFromFiltro.fechaInicial;
      fechaFinal = this.dataFromFiltro.fechaFinal;
    }

    this.servicioInformeVentaProducto
      .getVentasProducto(
        usuario,
        agencia,
        fechaInicial,
        fechaFinal,
        usuarioConsulta,
        distribuidora
      )
      .subscribe((result) => {
        console.log(result);
        this.dataVentaProducto = result;
        if (result.length > 0) {
          this.haveData = true;
        }

        if (this.timeRunning == 0) {
          this.dtTrigger.next();
        } else {
          this.reRender();
        }
        this.timeRunning++;
        this.loading = false;
      });
  }

  reRender() {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again

      this.dtTrigger.next();
    });
  }
}
